import React, { useCallback, useMemo } from "react";
import {
  FieldTypes,
  nameRegexValidator,
  urlRegexValidator,
} from "utils/formUtils";
import ModalUtil from "utils/modalUtil";
import { duplicateNameValidator } from "utils/validatorUtil";

import CommonTicketingForm from "../jira/CommonTicketingForm";
import ArcherIntegrationMappingForm from "./ArcherIntegrationMappingForm";

type ArcherIntegrationLoginFormProps = {
  config?: Record<string, any>;
  loginConfigList?: any[];
  name?: string;
  onUpdateConfigComponent?: (value: boolean) => void;
};

function ArcherIntegrationLoginform({
  loginConfigList,
  name,
  ...props
}: ArcherIntegrationLoginFormProps) {
  const fields = useMemo(() => {
    return [
      {
        name: "name",
        label: "Name",
        props: {
          autoFocus: true,
        },
        colSpan: 12,
        rules: [
          {
            required: true,
            message: "Name is required",
          },
          duplicateNameValidator({ list: loginConfigList }),
          nameRegexValidator,
        ],
      },
      {
        name: "url",
        label: "URL",
        colSpan: 12,
        required: true,
        rules: [urlRegexValidator()],
      },
      {
        name: "userName",
        label: "User Name",
        placeholder: "User Name",
        colSpan: 12,
        required: true,
      },
      {
        name: "apiToken",
        label: "Password",
        type: FieldTypes.PASSWORD,
        colSpan: 12,
        required: true,
      },
      {
        name: "organisation",
        label: "Instance Name",
        colSpan: 12,
        required: true,
      },
    ];
  }, [loginConfigList]);

  const handleMapping = useCallback(
    (loginConfigResponse) => {
      ModalUtil.show({
        content: (
          <ArcherIntegrationMappingForm
            onUpdateConfigComponent={props.onUpdateConfigComponent!}
            name={name!}
            loginConfigId={loginConfigResponse.id}
          />
        ),
      });
    },
    [props.onUpdateConfigComponent, name],
  );
  return (
    <CommonTicketingForm
      fields={fields}
      handleMapping={handleMapping}
      name={name}
      loginConfigList={loginConfigList}
      {...props}
    />
  );
}

export default ArcherIntegrationLoginform;
